import { ApiSchemaCaregiver } from "../models/api/caregiver";
import { Toggle, Modal, Button, Loader } from "rsuite";
import { ApiCaregiver } from "../core/apis/caregiver";
import { useState } from "react";
import { ActionsCaregiverTable } from "../core/redux";
import { useDispatch } from "react-redux";

export function NotificationToggle({
  caregiver,
}: {
  caregiver: ApiSchemaCaregiver;
}) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleToggle = async () => {
    setIsLoading(true);
    const response = await ApiCaregiver.ToggleNotification(
      caregiver,
      !caregiver.isNotificationEnabled
    );
    setIsLoading(false);
    handleClose();
    if (response.isSuccess) {
      dispatch(ActionsCaregiverTable.setRefetch(true));
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader size="sm" />
      ) : (
        <Toggle
          size="sm"
          onChange={handleOpen}
          disabled={isLoading}
          checked={caregiver.isNotificationEnabled}
        />
      )}
      <Modal open={open} onClose={handleClose}>
        <Modal.Body>
          <p>
            Turn notification {caregiver.isNotificationEnabled ? "off" : "on"}{" "}
            for {caregiver.firstName} {caregiver.lastName}?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            loading={isLoading}
            appearance="primary"
            onClick={handleToggle}
          >
            Ok
          </Button>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            appearance="subtle"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
